import axios from 'axios'

const baseURL = '/api'

export default class {

	constructor(version, resource) {
		this.version = version
		this.resource = resource
		this.url = `${baseURL}/v${version}/${resource}`
	}

	get(query) {
		return new Promise((resolve, reject) => {
			axios.get(query ? this.url + query : this.url)
			.then(response => {
				resolve(response.data)
			})
			.catch(err => {
				this._handleError(err)
				reject(err)
			})
		})
	}

	post(data) {
		return new Promise((resolve, reject) => {
			axios.post(this.url, data)
			.then(response => {
				resolve(response.data)
			})
			.catch(err => {
				this._handleError(err)
				reject(err)
			})
		})
	}

	delete(id) {
		return new Promise((resolve, reject) => {
			axios.delete(`${this.url}/${id}`)
			.then(response => {
				resolve(response.data)
			})
			.catch(err => {
				this._handleError(err)
				reject(err)
			})
		})
	}

	put(id, data) {
		return this._write('put', id, data)
	}

	patch(id, data) {
		return this._write('patch', id, data)
	}

	_write(method, id, data) {
		return new Promise((resolve, reject) => {
			axios.request({
				method,
				url: `${this.url}/${id}`,
				data
			})
			.then(response => {
				resolve(response.data)
			})
			.catch(err => {
				this._handleError(err)
				reject(err)
			})
		})
	}

	_handleError(err) {
		if(err.response) {
			if(err.response.status === 403 && this.resource !== 'users/login' && !document.location.pathname.startsWith('/view')) {
				localStorage.removeItem('userRole')
				document.location = '/login'
				return
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/lib/api.js